module.exports = __webpack_public_path__ + "static/media/cpq-quick-start-guides.27564d4f.svg";